import React, { useState, useEffect } from 'react';
import './LayerControl.css';
import apiService from '../services/apiService';

const LayerControl = ({ activeLayers, toggleLayer }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [layers, setLayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLayers = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiService.getGeoJsonLayers();
        
        if (response.layers && Array.isArray(response.layers)) {
          setLayers(response.layers);
        } else {
          setError('Ungültiges Datenformat vom Backend');
        }
      } catch (err) {
        console.error('Error fetching layers:', err);
        setError('Fehler beim Laden der Layer');
      } finally {
        setLoading(false);
      }
    };

    fetchLayers();
  }, []);

  return (
    <div className={`layer-control ${isOpen ? 'open' : 'closed'}`}>
      <div className="layer-control-header" onClick={() => setIsOpen(!isOpen)}>
        <h3>Kartenauswahl</h3>
        <span className="toggle-icon">{isOpen ? '▼' : '▶'}</span>
      </div>
      
      {isOpen && (
        <div className="layer-control-content">
          {loading && (
            <div className="layer-loading">
              <span className="loading-spinner">⏳</span>
              <span>Lade Layer...</span>
            </div>
          )}
          
          {error && (
            <div className="layer-error">
              <span>⚠️ {error}</span>
            </div>
          )}
          
          {!loading && !error && layers.length === 0 && (
            <div className="layer-empty">
              <span>Keine Layer verfügbar</span>
            </div>
          )}
          
          {!loading && !error && layers.map((layer) => (
            <div key={layer.name} className="layer-item">
              <label className="layer-label">
                <input
                  type="checkbox"
                  checked={activeLayers[layer.name] || false}
                  onChange={() => toggleLayer(layer.name)}
                />
                <span 
                  className="layer-color-indicator" 
                  style={{ backgroundColor: layer.color }}
                ></span>
                <span className="layer-name">{layer.name}</span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayerControl;
